<template>
  <div
    class="text-center tracking-tight flex flex-row gap-4 xl:gap-6 justify-center"
  >
    <div
      v-for="(spec, index) in specs"
      :key="index"
    >
      <font-awesome-icon
        class="pr-1"
        :icon="spec.icon"
      />
      {{ spec.value }}
    </div>
  </div>
</template>

<script>
import { faBed } from '@fortawesome/free-solid-svg-icons/faBed';
import { faBath } from '@fortawesome/free-solid-svg-icons/faBath';
import { faRulerCombined } from '@fortawesome/free-solid-svg-icons/faRulerCombined';
import { faRuler } from '@fortawesome/free-solid-svg-icons/faRuler';
import { isEmptyString } from 'mytribus-commons';
import { library } from '@fortawesome/fontawesome-svg-core';

export default {
  name: 'PropertySpecs',

  props: {
    property: {
      required: true,
      type: Object,
    },
  },

  computed: {
    /** @type {array} */
    specs() {
      return [
        {
          icon: 'bed',
          value: this.property.structure.bedrooms_total,
        },
        {
          icon: 'bath',
          value: this.property.structure.bathrooms_total_integer,
        },
        {
          icon: 'ruler-combined',
          value: this.getFormattedLivingArea(),
        },
        {
          icon: 'ruler',
          value: this.getFormattedLotSize(),
        },
      ]
        .filter((spec) => !isEmptyString(spec.value));
    },
  },

  created() {
    library.add(faBed);
    library.add(faBath);
    library.add(faRulerCombined);
    library.add(faRuler);
  },

  methods: {
    /** @return {null|string} */
    getFormattedLivingArea() {
      const {
        living_area: livingArea = null,
        living_area_units: livingAreaUnits = null,
      } = this.property.structure;

      if (
        livingArea === null
        || livingAreaUnits === null
      ) {
        return null;
      }

      return [
        Math.round(parseFloat(livingArea)).toLocaleString(),
        livingAreaUnits,
      ].join(' ');
    },

    /** @return {null|string} */
    getFormattedLotSize() {
      const {
        lot_size_units: lotSizeUnits = null,
        lot_size_area: lotSizeArea = null,
      } = this.property.characteristics;

      if (
        lotSizeUnits === null
        || lotSizeArea === null
      ) {
        return null;
      }

      const lotSizeAreaNum = parseFloat(lotSizeArea);

      return [
        lotSizeAreaNum.toFixed(2),
        lotSizeUnits,
      ].join(' ');
    },
  },
};
</script>
